// @ vendor
const Immutable = require('immutable');
// @ constants
const actionTypes = require('constants/actionTypes');
const hireCardOpenCreditStepINE = require('./hireCardOpenCredit/hireCardOpenCreditStepINE');

const initialState = Immutable.fromJS({
    'success': false,
    'error': '',
    'inProgress': false,
    'newLimit': 0,
    'newLimitIsDirty': false,
    'steps': [
        {
            valid: false
        },
        {
            hasSignaturePattern: true
        }
    ],
    'newSteps': [
        {
            valid: false
        },
        {
            valid: false
        },
        {
            hasSignaturePattern: true
        }
    ],
    willLeave: false,
    visibleStep: 1,
    willCancel: false,
    documentINE: false,
    scrollDown: false,
    scrollDownPolicy: false,
    agreeIneCheckbox: false,
    printDocument: false,
    creditId: false,
    fileINEDocument: false,
    cardsDocumentsPrintedAndSigned: undefined,
    printDocumentPolicy: false,
    confirmationCheckbox: false,
    confirmationCheckboxError: false,
    sendMail: false,
    confirmationCheckCc: false,
    fileINEDocumentId: false,
    operationProcessIdInitContract: false

});

function validateNewLimit(state) {
    const newLimit = state.get('newLimit');
    const valid = newLimit > 0;

    return state.setIn(['steps', 0, 'valid'], valid);
}
function validateNewStepsLimit(state, validStep) {
    const newLimit = state.get('newLimit');
    const valid = newLimit > 0;
    return state.setIn(['newSteps', validStep || 0, 'valid'], valid);
}
function creditPregrantedLimitVariationReducer(state = initialState, action) {
    let newState;
    switch (action.type) {
        case actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_SET_LIMIT:
            newState = state.mergeDeep({
                'newLimit': action.payload.limit,
                'newLimitIsDirty': true,
                'fileINEDocument': false
            });
            return validateNewLimit(newState);
        case actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_NEW_SET_LIMIT:
            newState = state.mergeDeep({
                'newLimit': action.payload.limit,
                'newLimitIsDirty': true,
                'fileINEDocument': false,
                cardsDocumentsPrintedAndSigned: undefined,
                printDocument: false,
                sendMail: false,
                operationProcessIdInitContract: false
            });
            return validateNewStepsLimit(newState);
        case actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_SET_VISIBLE_STEP:
            return state.set('visibleStep', action.payload.step);
        case actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_VALIDATE_STEP:
            newState = validateNewLimit(state);
            return newState.mergeDeep({
                'newLimitIsDirty': true
            });
        case actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_VALIDATE_NEW_STEP:
            newState = validateNewStepsLimit(state, action.payload.validStep);
            return newState.mergeDeep({
                'newLimitIsDirty': true,
                'valid': true
            });
        case actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_WILL_CANCEL:
            return state;
        case actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_CLEAR:
            return initialState;
        case actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_REQUEST:
            return state.merge({
                'inProgress': true
            });
        case actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_SUCCESS:
            return state.merge({
                'success': true,
                'inProgress': false
            });
        case actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_FAILURE:
            return state.merge({
                'error': action.payload.error,
                'inProgress': false
            });

        case actionTypes.RESET_INIT_CARDS_DOCUMENTS:
            return state.merge({
                documentINE: false,
                documentPolicy: false,
            });
        case actionTypes.CARDS_REQUEST_CONFIRM_SCROLL_DOWN:
            return state.merge({
                scrollDown: true,
            });
        case actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_RESET_CHECKBOX:
            return state.merge({
                scrollDown: false,
                agreeIneCheckbox: false
            });
        case actionTypes.CARDS_REQUEST_CONFIRM_SCROLL_DOWN_POLICY:
            return state.merge({
                scrollDownPolicy: true,
            });
        case actionTypes.HIRE_CARD_CREDIT_CARD_RESET_CHECKBOX:
            return state.merge({
                scrollDown: false,
                agreeIneCheckbox: false
            });
        case actionTypes.CARDS_CHECKED_DOCUMENT:
            return state.merge({
                agreeIneCheckbox: !state.get('agreeIneCheckbox'),
            });
        case actionTypes.HIRE_CARD_CREDIT_CARD_CHECK_RADIO_BUTTON:
            return state.merge({
                checkButtonRadio: action.payload.check,
                cardsDocumentsPrintedAndSigned: action.payload.check
            });
        case actionTypes.HIRE_CARD_CREDIT_CARD_PRINT_DOCUMENT:
            return state.merge({
                printDocument: action.payload.value,
            });
        case actionTypes.CREDIT_PREGRANTED_LIMIT_GET_ACCOUNT:
            return state.merge({
                creditId: action.payload.creditId,
            });
        case actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_SET_INIT:
            return state.merge({
                operationProcessIdInit: action.payload.operationProcessId,
            });
        case actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_SET_INIT_CONTRACT:
            return state.merge({
                operationProcessIdInitContract: action.payload.operationProcessId,
            });
        case actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_SET_TAE_TIN:
            return state.merge({
                debtorTin: action.payload.response.debtorTin,
                debtorTae: action.payload.response.debtorTae,
            });
        case actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_SET_INE:
            return state.merge({
                isFetchingINEDocument: false,
                fileINEDocument: action.payload.base64Document,
                fileINEDocumentId: action.payload.temporaryDocumentId,
                errorINEDocument: false
            });
        case actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_SET_POLICY:
            return state.merge({
                isFetchingPolicyDocument: false,
                filePolicyDocument: action.payload.base64Document,
                filePolicyDocumentId: action.payload.temporaryDocumentId,
                errorPolicyDocument: false
            });
        case actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_SET_POLICY_ERROR:
            return state.merge({
                error: true
            });
        case actionTypes.CARDS_CHECKED_DOCUMENT:
            return state.merge({
                agreeIneCheckbox: !state.get('agreeIneCheckbox'),
            });
        case actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_PRINT_INIT:
            return state.merge({
                printDocument: true
            });
        case actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_CHECK_RADIO_BUTTON:
            return state.merge({
                checkButtonRadio: action.payload.check,
                cardsDocumentsPrintedAndSigned: action.payload.check
            });
        case actionTypes.CREDIT_PREGRANTED_LIMIT_PRINT_POLICY:
            return state.merge({
                printDocumentPolicy: true,
                agreeIneCheckbox: true

            });
        case actionTypes.CREDIT_PREGRANTED_LIMIT_SCROLL_POLICY:
            return state.merge({
                scrollDownPolicy: true,
            });
        case actionTypes.HIRE_CARD_CREDIT_CARD_SET_AGREEMENT_CHECKBOX_CC:
            return state.merge({
                agreeIneCheckbox: !state.get('agreeIneCheckbox')
            });
        case actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_UPDATE_CONFIRMATION:
            return state.merge({
                confirmationCheckbox: !state.get('confirmationCheckbox'),
                confirmationCheckboxError: false
            });
        case actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_SEND_MAIL_SUCCESS:
            return state.merge({
                sendMail: true,
            });
        case actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_SEND_MAIL_CHECKBOX:
            return state.merge({
                confirmationCheckCc: true,
            });
        case actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_SET_LIMIT_INIT:
            return state.merge({
                initLimit: action.payload.newLimit,
            });
        default:
            return state;
    }
}

module.exports = creditPregrantedLimitVariationReducer;
